module.exports = __webpack_public_path__ + "static/media/twitter_icon.3b72de5f.svg";